
import Vue from 'vue'
import store from '@/store';
import { Component } from 'vue-property-decorator';


@Component({
  name: 'NotFoundComponent'
})

export default class NotFoundComponent extends Vue {
  public created(): void {
    (store.state as any).loader.isLoading = false;
  }
}
